<template>
    <div class="box">
        <div class="contaner-title"><span>项目管理</span> <span>/ 竞标项目</span> <span>/ {{PageTitle}}</span></div>
        <div class="hr"></div>
       
        <div class="contaner">
           <div><img src="../../assets/user_icon.png" alt=""> <span>{{PageTitle}}</span></div>
             <div>
                 <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="200">
                    <FormItem label="项目预算" prop="Apply_Fee">
                        <Input style="width:512px;"  v-model="formValidate.Apply_Fee"  placeholder=""></Input> 元
                    </FormItem>
                    <FormItem label="联系人" prop="Apply_ContactName">
                        <Input style="width:512px;"  v-model="formValidate.Apply_ContactName"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="电话/手机" prop="Apply_Tel">
                        <Input style="width:512px;"  v-model="formValidate.Apply_Tel"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="邮箱" prop="Apply_Email">
                        <Input style="width:512px;"  v-model="formValidate.Apply_Email"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="竞标说明" prop="Apply_Content">
                        <Input style="width:512px;" type="textarea" v-model="formValidate.Apply_Content" :rows="4"></Input>
                    </FormItem>
                    <FormItem label="预计开发时间" prop="Apply_Day">
                        <Input style="width:512px;"  v-model="formValidate.Apply_Day"  placeholder=""></Input> 天
                    </FormItem>
                    <FormItem label="上传附件" prop="Apply_Attach" >
                        <div style="display:flex;" class="uploadImg">
                            <Upload :action="uploadUrl" :on-success="successValid" :default-file-list="formValidate.Apply_Attach" :on-remove="deleValid" >
                                <Button type="primary" >点击上传</Button>
                            </Upload>
                        </div>
                    </FormItem>
                    <Form-item>
                        <div class="btn-sub">
                        <Button type="success" size="large" @click="handleSubmit('formValidate')"> 保 存 </Button>
                        <!-- <Button @click="handleReset('formValidate')" size="large"  style="margin-left: 8px"> 取 消 </Button> -->
                        </div>
                    </Form-item>
                </Form>
             </div>
        </div>
</div>
</template>
<script>
import changePws from "../../components/changePws.vue"
export default {
    components:{
       changePws
    },
    data(){
        return{
            ProjectID:'',
            MemberID:'',
            PageTitle:'',
            uploadUrl:this.$base,
            imgUrl:this.$baseImg,
            formValidate: {
                    Apply_Fee: '',//项目预算
                    Apply_Day: '',//预计开发时间
                    Apply_ContactName: '',//联系人
                    Apply_Tel:'',//手机号
                    Apply_Email: '',//邮箱
                    Apply_Content:'',//项目描述
                    Apply_Attach: []//附件地址
            },
            ClassList:[],
            ruleValidate: {
                Apply_Fee: [
                    { required: true,message: '项目预算不能为空', trigger: 'blur' }
                ],
                Apply_ContactName: [
                    { required: true,message: '联系人不能为空', trigger: 'blur' }
                ],
                Apply_Tel: [
                    { required: true, message: '手机号码不能为空', trigger: 'blur' },
                    { type: 'string',pattern:/^1[3456789]\d{9}$/, message:'请输入正确的手机格式', trigger:'blur'}
                ],
                Apply_Email: [
                    { required: true, message: '邮箱不能为空', trigger: 'blur' },
                    { type: 'string',pattern:/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, message:'请输入正确的邮箱格式', trigger:'blur'}
                ],
                Apply_Content: [
                    { required: true,message: '竞标说明不能为空', trigger: 'blur' }
                ],
            },
        }
    },
    mounted(){
        this.ProjectID = this.$route.query.ID;
        if (this.$route.query.Type == 1) {
            this.PageTitle = '修改竞标信息';
        } else {
            this.PageTitle = '添加竞标信息';
        }
        this.init();//初始化数据
    },
    methods:{
        deleValid(res){
            for (let i = 0; i < this.formValidate.Apply_Attach.length; i++) {
                if (this.formValidate.Apply_Attach[i].Path == res.Path) {
                    this.formValidate.Apply_Attach.splice(i,1);
                    break;
                }
            }
        },
        successValid(res, file){//附件上传成功
            if(res.code == 1){
                this.formValidate.Apply_Attach.push({'name':file.name,'url':res.Path});
            }
        },
         handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        for (let i = 0; i < this.formValidate.Apply_Attach.length; i++) {
                            delete this.formValidate.Apply_Attach[i].percentage
                            delete this.formValidate.Apply_Attach[i].status
                            delete this.formValidate.Apply_Attach[i].uid
                        }
                        var params={
                            ProjectID: this.ProjectID,
                            MemberID: this.MemberID,
                            Apply_Fee: this.formValidate.Apply_Fee,//项目预算
                            Apply_Day: this.formValidate.Apply_Day,//预计开发时间
                            Apply_ContactName: this.formValidate.Apply_ContactName,//联系人
                            Apply_Tel: this.formValidate.Apply_Tel,//手机号
                            Apply_Email: this.formValidate.Apply_Email,//邮箱
                            Apply_Content: this.formValidate.Apply_Content,//项目描述
                            Apply_Attach: this.formValidate.Apply_Attach//附件地址
                        }
                        if (!this.formValidate.Apply_Day) {
                            alert('预计开发时间不能为空');
                            return;
                        }
                        this.$post('api/manage.ProjectManage/editBiddingProject',params).then(res=>{
                            if(res.code==1){
                                this.$Message.success(res.msg);
                                this.$router.push({path:'BiddingProjectDetail', query:{ID:this.ProjectID}});
                            }else{
                                this.$Message.error(res.msg);
                            }
                        })
                    } else {
                        this.$Message.error('请将必填内容填写完整!');
                    }
                })
            },
        //初始化数据
        init() {
            let adminInfo = JSON.parse(this.$getLS('AdminInfo'));
            this.MemberID = adminInfo.ID;
            let params = {
                ProjectID : this.ProjectID,
                MemberID : this.MemberID
            }
                //获取项目详情
            this.$post('api/manage.ProjectManage/getBiddingProjectDetail', params).then(res=>{
                if (res.code == 1) {
                    let formValidate = res.data;
                    if (formValidate.Apply_Attach) {
                        formValidate.Apply_Attach = JSON.parse(formValidate.Apply_Attach);
                    } else {
                        formValidate.Apply_Attach = [];
                    }
                    this.formValidate = formValidate;
                    // console.log(this.formValidate);
                }
            })
        }
         
    }
}
</script>
<style lang="less" scoped>
.box{
    padding:30px;
    box-sizing: border-box;
  
    .contaner{
        background-color: #fff;
        margin-top: 30px;
        box-shadow: 0px 3px 5px #D9DDE3;
        >div:nth-of-type(1){
            overflow: hidden;
            padding:25px;
            border-bottom: 1px solid #E6E9EB;
            img{
                float: left;
            }
            span{
                float: left;
                font-size: 22px;
                color:#334659;
                margin-left: 10px;
            }
            button{
                float: right;
            }
        }
        >div:nth-of-type(2){
            padding:30px 0px;
            box-sizing: border-box;
            input{
                width: 156px;
            }
            .btn-sub{
                border-top: 1px solid #eee;
                padding-top: 20px;
                text-align: center;
            }
            .tab-form{
              
                .tab-btn{
                    display: flex;
                  span:nth-of-type(1){
                    font-size: 32px;
                    border:1px dashed #000;
                    margin-right:10px;
                    color: #000;
                   }
                   span:nth-of-type(2){
                       color: #334659;
                       font-weight: bold;
                       line-height: 32px;
                   }
                }
                .tab-list{
                    width: 430px;
                    overflow: hidden;
                    margin-top: 10px;
                    >span{
                        float: left;
                        border:1px solid #8795A4;
                        background-color:#EEEEEE;
                        color:#334659 ;
                        padding:0px 5px;
                        margin-right: 15px;
                        margin-bottom: 10px;
                        font-size: 12px;
                        line-height: 24px;
                        cursor: pointer;
                       
                    }
                     &>.active{
                         border-color: #01B7F3;
                         background-color:#DDF7FF;
                            color:#0198CD;
                        }
                }
            }
        }
    }
}
  .country{
                position: absolute;
                left: 0px;
                top: 37px;
                z-index: 999;
                width: 200px;
                background-color: #fff;
                border: 1px solid #eee;
                height: 300px;
                overflow-y: scroll;
                li{
                    padding-left: 10px;
                    line-height: 30px;
                  cursor: pointer;
                }
        }

</style>






// WEBPACK FOOTER //
// src/view/Project/PublishBiddingProject.vue